import React from "react";

/**
 * Reusable Access Denied page component.
 *
 * Props:
 *   message - optional custom message (default: "You don't have permission to view this page.")
 *   code    - optional error code (default: "403 forbidden")
 */
const AccessDenied = ({
  message = "You don't have permission to view this page.",
  code = "403 forbidden",
}) => (
  <div
    style={{
      textAlign: "center",
      display: "grid",
      alignItems: "center",
      alignContent: "center",
      height: "100%",
    }}
  >
    <h1 className="w3-jumbo w3-animate-top w3-center">
      <code>Access Denied</code>
    </h1>
    <h4 className="w3-center w3-animate-right">{message}</h4>
    <h3 className="w3-center w3-animate-zoom">🚫🚫🚫🚫</h3>
    <h6 className="w3-center w3-animate-zoom">error code: {code}</h6>
  </div>
);

export default AccessDenied;
